// add a description to the component visible on hover
//         }
//         let hours = parsedTime.hour();
//         if (hours === 24) hours = 0;
//
//         // Enforce business hours (8:00 - 20:00)
//         if (hours < 8) {
//           setNotValid(true);
//           handleClickVariant("L'heure doit être entre 8h et 20h", "error");
//           // set to 8h
//           parsedTime = parsedTime.hour(8);
//           setTime(parsedTime.format("HH:mm"));
//           onChange && onChange(parsedTime);
//           return;
//         }
//         if (hours > 20) {
import Tippy from "@tippyjs/react";
import React, { useState } from "react";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
function RangeTimePickerGPT0({
  force_8_to_20 = true,
  label,
  value = { start_seconds: "", end_seconds: "" },
  mandatory = false,
  onChange,
  className = "",
  autoComplete = "off",
  transparent = true,
  onEnter = () => {},
  focusOnStart = false,
  disabled = false,
}) {
  // i want to set dayjs to GMT 0*

  const { enqueueSnackbar } = useSnackbar();

  const [timeRange, setTimeRange] = useState({
    start: value.start_seconds
      ? dayjs()
          .startOf("day")
          .add(value.start_seconds, "second")
          .format("HH:mm")
      : "",
    end: value.end_seconds
      ? dayjs().startOf("day").add(value.end_seconds, "second").format("HH:mm")
      : "",
  });

  const [notValid, setNotValid] = useState({ start: false, end: false });

  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };

  const validateAndRoundTime = (timeString, type) => {
    let val = timeString.replace(/\D/g, ""); // Remove non-numeric characters
    if (val.length > 4) val = val.slice(0, 4);

    if (val.length >= 3) {
      val = `${val.slice(0, 2)}:${val.slice(2)}`;
    }

    // Prevent partial values from triggering errors
    if (val.length < 5) {
      return { formatted: val, parsed: null, isValid: false };
    }

    let parsedTime = dayjs(val, "HH:mm", true);
    if (!parsedTime.isValid())
      return { formatted: val, parsed: null, isValid: false };

    // Round to nearest 15 minutes
    let minutes = parsedTime.minute();
    let roundedMinutes = Math.round(minutes / 15) * 15;
    if (roundedMinutes === 60) {
      parsedTime = parsedTime.add(1, "hour").minute(0);
    } else {
      parsedTime = parsedTime.minute(roundedMinutes);
    }

    let hours = parsedTime.hour();
    if (hours === 24) hours = 0;

    // Enforce business hours (8:00 - 20:00)
    if (hours < 8 && force_8_to_20) {
      setNotValid((prev) => ({ ...prev, [type]: true }));
      handleClickVariant("L'heure doit être entre 8h et 20h", "error");
      // set to 8h
      parsedTime = parsedTime.hour(8);
      return {
        formatted: parsedTime.format("HH:mm"),
        parsed: parsedTime,
        isValid: true,
      };
    }
    if (hours > 20 && force_8_to_20) {
      setNotValid((prev) => ({ ...prev, [type]: true }));
      handleClickVariant("L'heure doit être entre 8h et 20h", "error");
      // set to 20h
      parsedTime = parsedTime.hour(20);
      return {
        formatted: parsedTime.format("HH:mm"),
        parsed: parsedTime,
        isValid: true,
      };
    }

    return {
      formatted: parsedTime.format("HH:mm"),
      parsed: parsedTime,
      isValid: true,
    };
  };

  const handleChange = (e, type) => {
    const { formatted, parsed, isValid } = validateAndRoundTime(
      e.target.value,
      type
    );

    setTimeRange((prev) => ({ ...prev, [type]: formatted }));
    setNotValid((prev) => ({ ...prev, [type]: !isValid }));

    if (isValid) {
      let newTimeRange = {
        start:
          type === "start" ? parsed : dayjs(timeRange.start, "HH:mm", true),
        end: type === "end" ? parsed : dayjs(timeRange.end, "HH:mm", true),
      };

      if (
        newTimeRange.start.isValid() &&
        newTimeRange.end.isValid() &&
        newTimeRange.start.isAfter(newTimeRange.end)
      ) {
        setNotValid({ start: false, end: true });
        handleClickVariant(
          "L'heure de fin doit être après l'heure de début",
          "error"
        );
        newTimeRange.end = newTimeRange.start;
        setTimeRange((prev) => ({
          ...prev,
          end: newTimeRange.end.format("HH:mm"),
        }));
      }

      const startSeconds =
        newTimeRange.start.hour() * 3600 + newTimeRange.start.minute() * 60;
      const endSeconds =
        newTimeRange.end.hour() * 3600 + newTimeRange.end.minute() * 60;

      onChange &&
        onChange({
          start_seconds: startSeconds,
          end_seconds: endSeconds,
        });
    }
  };

  const handleChangeOld = (e, type) => {
    const { formatted, parsed, isValid } = validateAndRoundTime(
      e.target.value,
      type
    );

    setTimeRange((prev) => ({ ...prev, [type]: formatted })); // Store formatted string for UI
    setNotValid((prev) => ({ ...prev, [type]: !isValid }));

    if (isValid) {
      // Convert stored values to dayjs objects
      let newTimeRange = {
        start:
          type === "start" ? parsed : dayjs(timeRange.start, "HH:mm", true),
        end: type === "end" ? parsed : dayjs(timeRange.end, "HH:mm", true),
      };

      // Ensure end time is after start time
      if (
        newTimeRange.start.isValid() &&
        newTimeRange.end.isValid() &&
        newTimeRange.start.isAfter(newTimeRange.end)
      ) {
        setNotValid({ start: false, end: true });
        handleClickVariant(
          "L'heure de fin doit être après l'heure de début",
          "error"
        );
        //set end to start
        newTimeRange.end = newTimeRange.start;
        setTimeRange((prev) => ({
          ...prev,
          end: newTimeRange.end.format("HH:mm"),
        }));
        onChange && onChange(newTimeRange);
        return;
      }

      onChange && onChange(newTimeRange); // Pass dayjs objects to parent
    }
  };

  return (
    <div className={`flex items-center space-x-2 w-full ${className}`}>
      <Tippy
        content={label}
        delay={500}
        className="custom-tooltip"
        disabled={!label}
      >
        <div className="flex items-center space-x-2">
          {/* Start Time Input */}
          <input
            disabled={disabled}
            type="text"
            placeholder="HH:mm"
            value={timeRange.start}
            autoFocus={focusOnStart}
            onKeyDown={handleKeyDown}
            onChange={(e) => handleChange(e, "start")}
            autoComplete={autoComplete}
            className={`
              w-24 h-8 px-2 py-1 rounded-xl border text-center
              ${mandatory && !timeRange.start ? "border-red-500" : "border-gray-300"}
              ${notValid.start ? "text-red-500 border-red-500" : ""}
              focus:border-2 focus:border-blue-300 outline-none transition duration-150
              ${disabled ? "bg-neutral-100 text-gray-500" : transparent ? "bg-transparent" : "bg-white"}
            `}
            style={{ fontSize: "14px" }}
          />

          <span className="text-gray-500">-</span>

          {/* End Time Input */}
          <input
            disabled={disabled}
            type="text"
            placeholder="HH:mm"
            value={timeRange.end}
            onKeyDown={handleKeyDown}
            onChange={(e) => handleChange(e, "end")}
            autoComplete={autoComplete}
            className={`
              w-24 h-8 px-2 py-1 rounded-xl border text-center
              ${mandatory && !timeRange.end ? "border-red-500" : "border-gray-300"}
              ${notValid.end ? "text-red-500 border-red-500" : ""}
              focus:border-2 focus:border-blue-300 outline-none transition duration-150
              ${disabled ? "bg-neutral-100 text-gray-500" : transparent ? "bg-transparent" : "bg-white"}
            `}
            style={{ fontSize: "14px" }}
          />
        </div>
      </Tippy>
    </div>
  );
}

export default RangeTimePickerGPT0;
